/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-18 14:20:22
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { InlineError, TextStyle, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Select, { components } from 'react-select';
import { SelectMinor } from '@shopify/polaris-icons';

import { RenderTooltip } from 'src/components/views/common/render-tooltip';
import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';
import { selectStyle } from 'src/components/views/common/forms/render-select.style';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

type Props = WithI18nProps;

const Option = ({ children, ...props }) => {
  const { data, language } = props;
  const { imageTooltip } = data;
  const imageTooltipDisplay = imageTooltip[language] || imageTooltip[APP_LANGUAGE_ENGLISH_VALUE];
  return (
    <components.Option {...props}>
      <div className="select-with-tooltip-option">
        <RenderTooltip
          content={<img src={imageTooltipDisplay} alt={data.label} />}
          children={children}
          delayHide={0.1}
          effect="float"
          place="right"
        />
      </div>
    </components.Option>
  );
};

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icon source={SelectMinor} color="base" />
      </components.DropdownIndicator>
    )
  );
};
class RenderButtonStyles extends Component<Props> {
  render() {
    const {
      meta,
      label,
      tooltip,
      input,
      isDisabled,
      textHelper,
      placeholder,
      options,
      i18n,
      language
    } = this.props;
    const hasError = !!meta.error && !!meta.touched;

    return (
      <div className={`${hasError ? 'Polaris-TextField--error' : ''}`}>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <Select
          options={options}
          id={input.name}
          value={input.value}
          onChange={value => {
            input.onChange(value);
          }}
          label={label}
          styles={{
            ...selectStyle,
            dropdownIndicator: (provided, state) => ({ ...provided, display: 'inherit' })
          }}
          placeholder={placeholder}
          maxMenuHeight={150}
          //$FlowFixMe
          menuPortalTarget={document.body}
          classNamePrefix="BC-Select"
          isDisabled={isDisabled ? true : false}
          noOptionsMessage={() => i18n.translate('AdminHTML.Common.Empty.reactSelect_NoOptions')}
          components={{
            DropdownIndicator,
            Option: optionProps => <Option {...optionProps} language={language} />
          }}
        />

        {textHelper ? (
          <p style={{ marginTop: '0.25rem' }}>
            <TextStyle variation="subdued">{textHelper}</TextStyle>
          </p>
        ) : (
          ''
        )}
        {meta.error ? <InlineError message={meta.error} /> : ''}
      </div>
    );
  }
}

export default withI18n()(RenderButtonStyles);
